var render = function render(){var _vm=this,_c=_vm._self._c;return _c('buttons-actions',_vm._g({attrs:{"creditNote":_vm.creditNote,"edit-mode":_vm.editMode,"has-more-than-two-actions":_vm.hasMoreThanTwoActions,"to-disable-save-changes":_vm.disableSaveChanges,"force-disable":_vm.forceDisable}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }